/**
 * Pure branch resolution logic – used by useBranchContext and unit tests.
 */
const DEFAULT_BRANCH_ID = 1;

export interface Branch {
  id: number;
  name: string;
  code: string | null;
  is_active: boolean | null;
}

export interface BranchResolutionInput {
  storedId: number | null;
  storedValid: boolean;
  storedActive: boolean;
  allowedBranchIds: number[];
  effectiveAssigned: number[];
  userBranchId: number | null;
  branches: Branch[];
}

export function resolveBranchId(input: BranchResolutionInput): number | null {
  const {
    storedId,
    storedValid,
    storedActive,
    allowedBranchIds,
    effectiveAssigned,
    userBranchId,
    branches,
  } = input;

  if (storedValid && storedActive && storedId != null) {
    return storedId;
  }

  const branch1 = branches.find((b) => b.id === DEFAULT_BRANCH_ID);
  const hasAccessToBranch1 =
    allowedBranchIds.includes(DEFAULT_BRANCH_ID) && branch1?.is_active === true;

  if (hasAccessToBranch1) {
    return DEFAULT_BRANCH_ID;
  }
  if (effectiveAssigned.length > 0) {
    return effectiveAssigned[0] ?? null;
  }
  if (userBranchId != null) {
    return userBranchId;
  }
  return branch1?.is_active === true ? DEFAULT_BRANCH_ID : branches[0]?.id ?? null;
}
